import Request from "network/request";
import NetworkCall from "../../network/networkCall";

export class ViewFieldOrder {
  static async getForClientByType(clientId, viewType, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getClientViewFieldOrder(clientId, viewType),
      useLoading,
    );
  }

  static async createForClient(clientId, viewType, data, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.createClientViewFieldOrder(clientId, viewType, data),
      useLoading,
    );
  }
}
